import { render, staticRenderFns } from "./CollectionsContainer.vue?vue&type=template&id=53813ef2&"
import script from "./CollectionsContainer.vue?vue&type=script&lang=js&"
export * from "./CollectionsContainer.vue?vue&type=script&lang=js&"
import style0 from "./CollectionsContainer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports